import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { WrapperHttpService } from '../../../../../services/wrapper-http-service';
import { API_URL } from '../../../../../../services/config';
import { getQueryStringFromObject } from '../../../../../../common/utils';
import { UliEndpoint } from '../constants/uli-endpoint';
import {
  UliPdfPreviewModel,
  UliPreviewInformationCriteria,
  UliPreviewInformationSmsCriteria,
} from '../models/uli-information-preview.model';

@Injectable({
  providedIn: 'root',
})
export class UliPreviewInformationService {
  constructor(private http: WrapperHttpService) {}

  public getUliInformationPreview(criteria: UliPreviewInformationCriteria): Observable<UliPdfPreviewModel> {
    const { uli, ...rest } = criteria;
    const url = `${API_URL}${UliEndpoint.Allocation}/${uli}${UliEndpoint.Information}${
      UliEndpoint.Preview
    }?${getQueryStringFromObject(rest)}`;
    return this.http.withLoading().get<UliPdfPreviewModel>(url);
  }

  public sendSms(criteria: UliPreviewInformationSmsCriteria): Observable<void> {
    const url = `${API_URL}${UliEndpoint.Allocation}${UliEndpoint.Information}${UliEndpoint.Send}`;
    return this.http.withLoading().post<void>(url, criteria);
  }
}
